import axios from '../../helpers/interceptors';

import {
    TEST,
    REGISTRATION_STARTED,
    REGISTRATION_SUCCESS,
    REGISTRATION_FAILURE,
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    FORGOT_PASSWORD_STARTED,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    SET_AUTHORIZATION_STATUS,
    SET_INVITATION_CODE_STARTED,
    SET_INVITATION_CODE_SUCCESS,
    SET_INVITATION_CODE_FAILURE,
    LOGOUT_STARTED,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE
} from "./types";

import {api} from "../../api";
// // axios.defaults.withCredentials = true;
const host = api.host;


export const test = data => ({
    type: TEST,
    payload: data
});

export const setAuthorizationStatus = status => ({
    type: SET_AUTHORIZATION_STATUS,
    payload: status
});



export const registration = (formData, successHandler) => {
    let url = host + api.registration;

    return dispatch => {
        dispatch(registrationStarted());
        axios.post(url, formData)
            .then(res => {
                localStorage.setItem('tc-token', res.data.response.token);
                dispatch(registrationSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
                if (successHandler) {
                    successHandler();
                }
            })
            .catch(err => {
                dispatch(registrationFailure(err?.response?.data?.errors));
            });
    };
};

const registrationStarted = () => ({
    type: REGISTRATION_STARTED
});

export const registrationSuccess = serverReport => ({
    type: REGISTRATION_SUCCESS,
    payload: serverReport
});

export const registrationFailure = error => ({
    type: REGISTRATION_FAILURE,
    payload: error
});


export const login = (formData) => {
    let url = host + api.login;


    return dispatch => {
        dispatch(loginStarted());
        axios.post(url, formData)
            .then(res => {
                localStorage.setItem('tc-token', res.data.response.token);
                dispatch(loginSuccess(res.data.response));
                dispatch(setAuthorizationStatus(true));
            })
            .catch(err => {
                dispatch(loginFailure(err?.response?.data?.errors));
            });
    };
};


// ---------------------------------------------------------------------------
// Восстановление пароля.
// Письмо со ссылкой {FRONTEND_URL}/reset-password?token=…&email=… живёт час.
// Ответ на запрос письма всегда одинаковый — по нему нельзя проверить, есть
// такая почта в базе или нет. После смены пароля сервер отзывает все токены
// пользователя, поэтому входить придётся заново
// ---------------------------------------------------------------------------

export const forgotPassword = (email, successHandler) => {
    let url = host + api.forgotPassword;

    return dispatch => {
        dispatch({type: FORGOT_PASSWORD_STARTED});
        axios.post(url, {email})
            .then(res => {
                dispatch({type: FORGOT_PASSWORD_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: FORGOT_PASSWORD_FAILURE, payload: err?.response?.data});
            });
    };
};

export const forgotPasswordFailure = error => ({
    type: FORGOT_PASSWORD_FAILURE,
    payload: error
});


// data: {token, email, password, password_confirmation}
export const resetPassword = (data, successHandler) => {
    let url = host + api.resetPassword;

    return dispatch => {
        dispatch({type: RESET_PASSWORD_STARTED});
        axios.post(url, data)
            .then(res => {
                dispatch({type: RESET_PASSWORD_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: RESET_PASSWORD_FAILURE, payload: err?.response?.data});
            });
    };
};

export const resetPasswordFailure = error => ({
    type: RESET_PASSWORD_FAILURE,
    payload: error
});


const loginStarted = () => ({
    type: LOGIN_STARTED
});

export const loginSuccess = serverReport => ({
    type: LOGIN_SUCCESS,
    payload: serverReport
});

export const loginFailure = error => ({
    type: LOGIN_FAILURE,
    payload: error
});


export const setInvitationCode = (code) => {
    const url = host + api.invitationCode + `/${code}`;

    return (dispatch) => {
        dispatch(setInvitationCodeStarted());

        return axios.get(url)
            .then((res) => {
                dispatch(setInvitationCodeSuccess(res));
                return res;
            })
            .catch((err) => {
                dispatch(setInvitationCodeFailure(err));
                throw err;
            });
    };
};

const setInvitationCodeStarted = () => ({
    type: SET_INVITATION_CODE_STARTED
});

export const setInvitationCodeSuccess = serverReport => ({
    type: SET_INVITATION_CODE_SUCCESS,
    payload: serverReport
});

export const setInvitationCodeFailure = error => ({
    type: SET_INVITATION_CODE_FAILURE,
    payload: error
});


export const logout = () => {
    let url = host + api.logout;
    const token = localStorage.getItem('tc-token');

    return dispatch => {
        dispatch(logoutStarted());
        axios.post(url, null, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                localStorage.removeItem('tc-token');
                dispatch(setAuthorizationStatus(false));
                // dispatch(clearCabinetState());
            })
            .catch(err => {
                localStorage.removeItem('tc-token');
                dispatch(setAuthorizationStatus(false));
                dispatch(logoutFailure(err));
                // dispatch(clearCabinetState());
            });
    };
};

const logoutStarted = () => ({
    type: LOGOUT_STARTED
});

export const logoutSuccess = serverReport => ({
    type: LOGOUT_SUCCESS,
    payload: serverReport
});

export const logoutFailure = error => ({
    type: LOGOUT_FAILURE,
    payload: error
});






